var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLs(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-ls",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 358.4h512V512H0z",
    fill: "#009543"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v153.6H0z",
    fill: "#00209f"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M257.597 163.104c-2.918.064-5.765 3.294-5.765 3.294l.253 34.533-10.903 11.421h8.824l-.074 19.8-52.208 70.303-7.718-2.667-13.49 28.776s33.364 20.891 81.793 20.321c53.15-.631 82.029-21.285 82.029-21.285l-13.94-28.406-6.827 2.97-52.877-69.94-.074-20.39h8.824l-12.01-11.282.072-34.405s-2.99-3.106-5.909-3.043z",
    stroke: "#000",
    strokeWidth: 1.708
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M275.8 245.777h-36.1s-13.105-27.609-10.98-46.91c2.163-19.653 13.394-28.95 28.328-29.115 17.655-.196 26.909 8.653 29.704 28.329 2.77 19.497-10.953 47.694-10.953 47.694z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 8.534
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M194.491 311.586c-.59.785-4.918 9.441-4.918 9.441l7.475-1.573-2.557-7.868zm4.328 11.213l-7.867 2.557 9.441 3.737-1.574-6.294zm3.54-11.017l3.936 11.606 9.639-2.753-2.558-5.51-11.017-3.344zm6.1 15.738l1.375 4.72 12.788 3.149-5.115-10.82-9.048 2.95zm14.162-9.836l4.526 10.82 9.639-3.737-3.149-4.723-11.015-2.36zm6.296 14.754l1.573 4.13 14.95 2.164-6.294-9.835-10.23 3.541zm14.36-11.607l5.509 9.64 13.965-5.115-1.573-3.738-17.902-.785zm8.065 13.18l2.951 5.116 17.31-.59-6.491-9.64-13.77 5.115zm18.296-12.786l4.72 8.064 11.017-5.31-2.953-4.329-12.784 1.575zm18.097 6.097l-11.016 5.509 2.95 4.72 14.755-2.36-6.69-7.868zm3.541-8.459l5.704 7.083 9.247-7.279-3.149-3.345-11.802 3.541zm16.917 3.738l-8.853 6.69 2.362 4.13 12.196-3.147-5.705-7.673zm12.197-13.967l2.163 3.148-6.098 9.05-6.294-8.067 10.23-4.13zm4.13 7.869l3.738 7.475-7.475 2.559-.59-3.542 4.328-6.492z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLs);
export default __webpack_public_path__ + "static/media/ls.a9440b7fbc30c7b44c3777199be2314a.svg";
export { ForwardRef as ReactComponent };